(() => {
  document.querySelectorAll('[data-kit-gallery]').forEach(gallery => {
    const buttons = [...gallery.querySelectorAll('[data-kit-thumb]')];
    buttons.forEach(button => button.addEventListener('click', () => {
      gallery.querySelectorAll('[data-kit-slide]').forEach(slide => { slide.hidden = slide.dataset.kitSlide !== button.dataset.kitThumb; });
      buttons.forEach(other => other.setAttribute('aria-pressed', String(other === button)));
    }));
  });
  document.querySelectorAll('[data-kit-faq] details').forEach(details => {
    const summary = details.querySelector('summary');
    const answer = details.querySelector('.rf-kit-faq__answer');
    if (!summary || !answer) return;
    let animation = null, expanding = details.open;
    summary.addEventListener('click', event => {
      if (matchMedia('(prefers-reduced-motion:reduce)').matches || !details.animate) return;
      event.preventDefault();
      const start = details.getBoundingClientRect().height;
      expanding = animation ? !expanding : !details.open;
      if (animation) { animation.onfinish = null; animation.oncancel = null; animation.cancel(); }
      details.open = true;
      const target = summary.getBoundingClientRect().height + (expanding ? answer.getBoundingClientRect().height : 0) + 1;
      animation = details.animate({height:[start+'px',target+'px']},{duration:280,easing:'cubic-bezier(.2,.8,.2,1)'});
      animation.onfinish = () => { details.open = expanding; animation = null; };
      animation.oncancel = () => { animation = null; };
    });
  });
})();